import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables';
import { PERMISSIONS_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { externalApplicationColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import { EnumFrontendLayoutSetting, type ApiExternalApplication } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { ApplicationsRepository } from '@Repositories/Permissions';

export function FrameListExternalApplication() {
    const hasPermission = useHasPermission();

    const module = useListApi(ApplicationsRepository, PERMISSIONS_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiExternalApplication>
            layoutSettingsContext={EnumFrontendLayoutSetting.ExternalApplicationsTableLayout}
            name="ExternalApplicationsList"
            columns={externalApplicationColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.PermissionsExternalApplicationsRead)}
            useOnClickNavigation
            fullSize
        />
    );
}
